import { render } from "./DataSourcesOnvifProfileStreams.vue?vue&type=template&id=76120a70&ts=true"
import script from "./DataSourcesOnvifProfileStreams.vue?vue&type=script&lang=ts"
export * from "./DataSourcesOnvifProfileStreams.vue?vue&type=script&lang=ts"

import "./DataSourcesOnvifProfileStreams.vue?vue&type=style&index=0&id=76120a70&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__